import Collapse from 'antd/es/collapse';
import styled from 'styled-components';

export const DotStyle = styled.div`
  width: 36px;
  height: 36px;
  background-color: ${({ theme }) => theme.palette.primaryBrand};
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.white};
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

export const TimeLineStyle = styled.div`
  display: flex;
  justify-content: space-between;
  li > div:first-child {
    height: 100%;
  }
  li > div:nth-child(1) {
    border-image: repeating-linear-gradient(
      to bottom,
      transparent 50%,
      transparent 100%
    );
    background: repeating-linear-gradient(
        to bottom,
        transparent 0 6px,
        ${({ theme }) => theme.palette.lightBlueGrey} 6px 12px
      )
      100%/2px 100% no-repeat;
  }

  .setur-timeline-item-content {
    width: 100%;
    top: -20px;
    padding-right: 12px;

    @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
      margin-left: 30px;
      top: -10px;
    }
  }

  .setur-timeline-item-last {
    padding-bottom: 0px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
    flex-direction: column;

    .setur-timeline-item-label {
      width: 30px !important;
    }

    .setur-timeline.setur-timeline-alternate
      .setur-timeline-item-left
      .setur-timeline-item-content,
    .setur-timeline.setur-timeline-right
      .setur-timeline-item-left
      .setur-timeline-item-content,
    .setur-timeline.setur-timeline-label
      .setur-timeline-item-left
      .setur-timeline-item-content {
      left: 36px;
      width: calc(100% - 64px);
    }

    .setur-timeline.setur-timeline-alternate .setur-timeline-item-tail,
    .setur-timeline.setur-timeline-right .setur-timeline-item-tail,
    .setur-timeline.setur-timeline-label .setur-timeline-item-tail,
    .setur-timeline.setur-timeline-alternate .setur-timeline-item-head,
    .setur-timeline.setur-timeline-right .setur-timeline-item-head,
    .setur-timeline.setur-timeline-label .setur-timeline-item-head,
    .setur-timeline.setur-timeline-alternate .setur-timeline-item-head-custom,
    .setur-timeline.setur-timeline-right .setur-timeline-item-head-custom,
    .setur-timeline.setur-timeline-label .setur-timeline-item-head-custom {
      left: 43px;
    }
  }
`;

export const CollapseStyle = styled(Collapse)`
  &&& {
    border: none;
    background-color: ${({ theme }) => theme.palette.white};

    .setur-collapse-header,
    .setur-collapse > .setur-collapse-item > .setur-collapse-header {
      padding: 10px !important;
      @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
        padding: 20px;
      }
    }

    .setur-collapse-content,
    .setur-collapse-item-active {
      border-top: solid 1px ${({ theme }) => theme.palette.gray87};
      border-radius: 8px;
    }

    .setur-collapse-content > .setur-collapse-content-box {
      padding: 10px;
      @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
        padding: 16px 16px 0px 16px;
      }
    }

    .setur-collapse-item {
      border: solid 1px ${({ theme }) => theme.palette.gray87};
      min-height: 96px;
      @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
        width: initial;
        min-height: initial;
      }
    }
    .setur-collapse-item:last-child {
      border: solid 1px ${({ theme }) => theme.palette.gray87};
      border-radius: 8px;
    }
    .setur-collapse-item-active {
      box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
      background-color: ${({ theme }) => theme.palette.white};
    }
  }
`;

export const DayNo = styled.div`
  opacity: 0.75;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const DayName = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
  }
`;
